const windowDocument = typeof document !== 'undefined' && document

const init = (env) => {
  if (windowDocument) {
    const script = windowDocument.createElement("script");

    script.innerHTML = `(function(){window.WhistleLiveChat={ company:'${env.GATSBY_LIVE_CHAT_BUCKET}', source: '${env.GATSBY_PLUGINS_SOURCE}' };var e=document.createElement("script");e.async=!0,e.type="text/javascript",e.src=window.WhistleLiveChat.source + "/live-chat/initialize.js";var t=document.getElementsByTagName("script")[0];t.parentNode.insertBefore(e,t)}())`
    script.async = true;
    script.defer = true

    document.body.appendChild(script);
  }
}

export default init


// WEBPACK FOOTER //
// ./src/utils/livechat.js